import { gql } from '@/shared/graphql/generated/cache';
import { type CacheValidatorFragment } from '@/shared/graphql/generated/cache/graphql';
import { type TokenCast } from '@/shared/utils/TokenAmount';

gql(/* GraphQL */ `
  fragment CacheValidator on Validator {
    idHex
    idSs58
    alias
    apyBp
    boundRedeemAddress
    isCurrentAuthority
    isCurrentBackup
    isQualified
    isOnline
    isBidding
    isKeyholder
    reputationPoints
    lockedBalance
    unlockedBalance
    totalBalance
    lockedBalanceValueUsd
    unlockedBalanceValueUsd
    totalBalanceValueUsd
    bid
    bidValueUsd
    accountBid
    accountBidValueUsd
    totalBid
    totalBidValueUsd
  }
`);
export const cacheValidatorCastFields = [
  'lockedBalance',
  'unlockedBalance',
  'totalBalance',
] as const;
export type CastCacheValidatorFragment = TokenCast<
  CacheValidatorFragment,
  (typeof cacheValidatorCastFields)[number]
>;
